
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';
    import ApexCharts from 'apexcharts'
    import VueApexCharts from 'vue-apexcharts'

    @Component({
        components: { apexcharts: VueApexCharts, VWidget },
        watch: {
            period: function (val) {
                (this as any).loadData();
            }
        }
    })

    export default class ChartOperation extends ListBase {
        @Prop({ type: Number, default: 0 }) dealer: number;
        month: number = parseInt(new Date().toISOString().substr(5, 2)) - (parseInt(new Date().toISOString().substr(5, 2)) > 1 ? 1 : 0);
        year: number = this.period;

        get options() {
            let base = {
                chart: {
                    height: 350,
                    type: 'radialBar',
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                            margin: 0,
                            size: '60%',
                            background: '#fff',
                            image: undefined,
                            imageOffsetX: 0,
                            imageOffsetY: 0,
                            position: 'front',
                            dropShadow: {
                                enabled: true,
                                top: 3,
                                left: 0,
                                blur: 4,
                                opacity: 0.24
                            }
                        },
                        track: {
                            background: '#fff',
                            strokeWidth: '67%',
                            margin: 0, // margin is in pixels
                            dropShadow: {
                                enabled: true,
                                top: -3,
                                left: 0,
                                blur: 4,
                                opacity: 0.35
                            }
                        },

                        dataLabels: {
                            show: true,
                            name: {
                                offsetY: -10,
                                show: true,
                                color: '#888',
                                fontSize: '17px'
                            },
                            value: {
                                //formatter: function (val) {
                                //    return parseInt(val);
                                //},
                                color: '#111',
                                fontSize: '24px',
                                show: true,
                            }
                        }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#ABE5A1'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
                stroke: {
                    lineCap: 'round'
                },
                labels: [this.L('Ind. Satisfaccion')],
            };

            let opt1 = Util.extend(true, {}, base);
            let opt2 = Util.extend(true, {}, base);
            let opt3 = Util.extend(true, {}, base);

            opt1.labels = [this.L('Ind. Satisfaccion')];
            opt1.plotOptions.radialBar.dataLabels.value.formatter = function (val) {
                return parseInt(val);
            };
            opt2.labels = [this.L('Pasos')];
            opt2.plotOptions.radialBar.dataLabels.value.formatter = function (val) {
                return parseInt(val);
            };
            opt3.labels = [this.L('Facturacion')];
            opt3.plotOptions.radialBar.dataLabels.value.formatter = function (val) {
                return 'S/ ' + new Intl.NumberFormat().format(parseInt(val));
            };

            return [opt1, opt2, opt3]
        }

        get period() {
            return this.$store.state.dashboard.period;
        }
        
        get series() {
            let model = this.$store.state.dashboard.compliances[this.dealer == null ? 0 : this.dealer];
            if (model == null) return [0];
            return [model.satis];
        }

        get series2() {
            let model = this.$store.state.dashboard.compliances[this.dealer == null ? 0 : this.dealer];
            if (model == null) return [0];
            return [model.steps];
        }

        get series3() {
            let model = this.$store.state.dashboard.compliances[this.dealer == null ? 0 : this.dealer];
            if (model == null) return [0];
            return [model.invoi];
        }
        
        get loading() {
            return this.$store.state.dashboard.loading;
        }

        get months() {
            let list = this.gCommonList('months');
            return [
                { id: 0, name: '<<Todos>>' },
                ...list
            ];
        }

        get periods() {
            return this.gCommonList('years');
        }

        async loadData() {
            await this.$store.dispatch({
                type: 'dashboard/getChartCompliance',
                data: {
                    year: this.year,
                    month: this.month,
                }
            });          
        }

        mounted() { 
            this.loadData();
        }
    }
